export const fundDistributorsOptions = [
  { value: 'fmarket', label: 'Fmarket' },
  { value: 'nhsv', label: 'NHSV' },
  { value: 'vcam', label: 'VCAM' },
];
